import PhoneInput from "react-phone-number-input";
import { useField } from "formik";
import React from "react";
const PhoneInputField = ({ label, ...props }) => {
    // eslint-disable-next-line no-unused-vars
    const [field, _, helpers] = useField(props.name);

    return (
        // <FieldWrapper label={label} meta={meta} {...props}>
            <PhoneInput
                {...props}
                {...field}
                value={field.value}
                countrySelectProps={{  disabled: true }}
                onChange={(value) => {
                    helpers.setValue(value);
                }}
                maxLength={12}
                international={false}
                autoComplete="off" 
            />
        // </FieldWrapper>
    );
};

export default PhoneInputField;
